import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError, tap, map, Subject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    constructor(private http: HttpClient, private authService: AuthService) { }

    // get ME

    user: any;
    userChanges: Subject<any> = new Subject<any>();

    getMe() {
        return this.http.get<any>(`${environment.apiUrl}/me`).pipe(
            map((data: any) => {
                this.user = data.user;
                if(!this.user.firstname && this.user.firstname != null) {
                    this.user.firstname = this.user.firstname.charAt(0).toUpperCase() + this.user.firstname.slice(1);
                }else{
                    this.user.firstname = 'Guest';
                }
                this.userChanges.next(this.user);
                return data.user;
            }),
            catchError((error) => {
                return throwError(() => error);
            })
        );
    }

    approveCGU(isApproved: boolean) {
        return this.http.post<any>(`${environment.apiUrl}/cgu`, {
            approved_cgu: isApproved
        }).pipe(
            map((data: any) => {
                return data;
            }),
            catchError((error) => {
                return throwError(() => error);
            })
        );
    }


    // AGENTS

    agents: any;
    agentsChanges: Subject<any> = new Subject<any>();

    getAgents(forced_company_id?: any) {
        let company_id: any = 1;
        let public_key: any = null;
        let url = `${environment.apiUrl}/agents`;
        if (localStorage.getItem('company_id')) {
            company_id = localStorage.getItem('company_id');
            url = `${environment.apiUrl}/agents?company_id=${company_id}`;
        }
        if (localStorage.getItem('public_key')) {
            public_key = localStorage.getItem('public_key');
            url = `${environment.apiUrl}/agents?public_key=${public_key}`;
        }


        return this.http.get<any[]>(url).pipe(
            tap((agents: any) => {
                this.agents = agents.data; // On stocke ici
                
                // double this.agents pour simuler le fait d'avoir plus d'agents
                // this.agents = [...this.agents, ...this.agents];
                // this.agents = [...this.agents, ...this.agents];

                this.agentsChanges.next(this.agents); // On émet l'événement
            })
        );
    }

    getAgent(id: number) {
        return this.http.get(`${environment.apiUrl}/agents/${id}`);
    }

    async runAgent(id: any, step: any, options?: { content?: any, document_id?: any, agent_choice_id?: any, conversation?: any, conversation_id?: any, documents_ids?: any, to_save?: any, webDiscussionId?: any }) {

        const data: any = { step };


        if (options) {
            if (options.conversation) data.conversation = options.conversation;
            if (options.conversation_id) data.rag_answer_id = options.conversation_id;
            if (options.documents_ids) data.documents_ids = options.documents_ids;
            if (options.to_save) data.save = options.to_save;
            if (options.webDiscussionId) data.web_discussion_id = options.webDiscussionId;
            if (options.content) data.content = options.content;
            if (options.document_id) data.document_id = options.document_id;
            if (options.agent_choice_id) data.agent_choice_id = options.agent_choice_id;
        }

        return new Observable<string>((observer) => {
            fetch(`${environment.apiUrl}/agents/${id}/run`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // 'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    // 'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'Authorization': `Bearer ${this.authService.getToken()}`,
                },
                body: JSON.stringify(data)
            }).then(async (response) => {
                const reader = response.body?.getReader();
                const decoder = new TextDecoder('utf-8');

                let finalResult = '';

                const readChunk = async () => {
                    if (!reader) return observer.error('Stream non disponible');

                    while (true) {
                        const { done, value } = await reader.read();
                        if (done) {
                            const flushed = decoder.decode(); // flush le reste
                            if (flushed) {
                                finalResult += flushed;
                                observer.next(flushed);
                            }
                            break;
                        }

                        const chunk = decoder.decode(value, { stream: true });
                        // console.log('📥 Chunk reçu:', chunk);
                        finalResult += chunk;
                        observer.next(chunk);
                    }

                    observer.complete();
                };

                readChunk();
            }).catch((err) => observer.error(err));
        });
    }





    // DOCUMENTS

    getDocuments(company_id?: any): Observable<any> {

        let params = new HttpParams();
        params = params.append('page', '1');
        params = params.append('per_page', '10');
        params = params.append('statut', '2');

        if (company_id) {
            params = params.append('company_id', company_id);
        }

        // return this.http.get(`${environment.apiUrl}/documents`, {params});
        return this.http.get(`${environment.apiUrl}/documents`, { params });
    }
}
